<template>
  <div>
    <!-- <ButtonVcita/> -->
    <div class="form__main">
      <div class="wraper__main">
        <div class="content">
          <div class="main__about">
            <img class="about__logo" src="../assets/img/v.svg">
            <div class="about__description">
              <h2 class="description__title">vCita</h2>
              <div class="description__text">{{ $t("settings.vcitaDescription") }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="tabs__main">
        <div id="wix_app_info"></div>
      </div>
      <div class="tabs__footer">
        <p>You are logged in to vCita payments as:</p>
        <p class="who__email">baruch@dego.com</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'wixcallback',
  props: ['code', 'instanceid', 'state'],
  data: function () {
    return { wcode: this.code, winstanceid: this.instanceid, wstate: this.state }
  },
  methods: {
    onCallback: function (authcode, instanceID) {
      const request = new XMLHttpRequest()
      request.open('POST', 'https://www.wix.com/oauth/access', true)
      request.setRequestHeader('Content-Type', 'application/json')

      const reqd = {
        'grant_type': 'authorization_code',
        'client_id': '8c74cf5b-ca04-4820-afcd-826f52daf2f6',
        'client_secret': '14bffcbc-44a4-4e51-b2a5-c189e44a8f77',
        'code': authcode
      }

      request.onerror = function (e) {
        console.log(e.target)
      }

      request.onload = function (e) {
        const info = document.getElementById('wix_app_info')
        console.log(e.target)
        console.log(e.target.responseText)
        const rd = JSON.parse(e.target.responseText)
        info.innerHTML = 'Your application is authorized with Access Token ' + rd.access_token + ' and Refresh Token ' + rd.refresh_token
      }

      request.send(reqd)
    }
  },
  mounted: function () {
    if (typeof this.wcode === 'undefined' || this.wcode === null || this.wcode.length === 0) {
      alert('code ' + this.wcode + ' is not recognized')
      return false
    }
    this.onCallback(this.wcode, this.winstanceid)
  }
}
</script>

<style lang="scss">
@import "../assets/style/_global.scss";
</style>
